/** 会员端安全素材 DTO — 不含 prompt / meta 全文 / provider 字段 */

export interface MemberSafeAsset {
  asset_id: number;
  character_id: number | null;
  task_id: number | null;
  url: string | null;
  asset_type: string;
  status: string;
  display_status: string;
  created_at: string;
  updated_at: string;
  title: string | null;
  display_label: string | null;
  business_use_case: string | null;
  render_intent: string | null;
  public_note: string | null;
  is_review_pending: boolean;
  is_failed: boolean;
  is_refunded: boolean;
  material_type: string | null;
  scene_type: string | null;
  usage_purpose: string | null;
  display_mode: string | null;
  photo_subtype: string | null;
  motion: string | null;
}

export interface MemberSafeMediaJob {
  job_row_id: number;
  job_id: string | null;
  display_type: string;
  display_status: string;
  status_label: string;
  status_description: string;
  estimated_wait_hint: string | null;
  can_leave: boolean;
  leave_hint: string | null;
  created_at: string;
  updated_at: string;
  completed_at: string | null;
  failed_public_reason: string | null;
  refund_status: string | null;
  output_url: string | null;
  user_input_preview: string | null;
}

export interface PublicQueueStatusRow {
  status: PublicQueueStatus;
  label: string;
  description: string;
}

export type PublicQueueStatus =
  | 'smooth'
  | 'busy'
  | 'peak'
  | 'degraded'
  | 'maintenance';

/** 任务板兼容：仅保留 url/status/id + display_mode */
export function safeAssetToBoardView(a: MemberSafeAsset): {
  id: number;
  created_at: string;
  character_id: number | null;
  task_id: number | null;
  asset_type: 'image' | 'video' | 'audio';
  url: string | null;
  source: null;
  prompt: null;
  status: MemberSafeAsset['status'];
  meta: { mode?: string } | null;
} {
  return {
    id: a.asset_id,
    created_at: a.created_at,
    character_id: a.character_id,
    task_id: a.task_id,
    asset_type: a.asset_type as 'image' | 'video' | 'audio',
    url: a.url,
    source: null,
    prompt: null,
    status: a.status as MemberSafeAsset['status'],
    meta: a.display_mode ? { mode: a.display_mode } : null,
  };
}

/** 素材库页兼容 id */
export function safeAssetToMaterialRow(a: MemberSafeAsset): {
  id: number;
  created_at: string;
  character_id: number | null;
  asset_type: 'image' | 'video' | 'audio';
  url: string | null;
  status: string;
  material_type: string | null;
  scene_type: string | null;
  usage_purpose: string | null;
  photo_subtype: string | null;
  motion: string | null;
} {
  return {
    id: a.asset_id,
    created_at: a.created_at,
    character_id: a.character_id,
    asset_type: a.asset_type as 'image' | 'video' | 'audio',
    url: a.url,
    status: a.status,
    material_type: a.material_type,
    scene_type: a.scene_type,
    usage_purpose: a.usage_purpose,
    photo_subtype: a.photo_subtype,
    motion: a.motion,
  };
}
